import { gql } from '@apollo/client';

export const REQUEST_FILE_UPLOAD = gql`
  mutation RequestFileUpload($fileSize: Long!, $fileName: String, $fileType: String) {
    uploadRequest(
      input: {
        application: SUPPORT_PAGES
        fileSize: $fileSize
        fileName: $fileName
        fileType: $fileType
      }
    ) {
      error {
        id
        message
      }
      success {
        id
        authToken
        url
      }
    }
  }
`;

export default REQUEST_FILE_UPLOAD;
